import { object, string, ObjectSchema, number } from 'yup';

export const allergySeveritySchema: ObjectSchema<{ severity: string }> = object(
  {
    severity: string().required('Allergy Severity Required'),
  }
);

export const allergyDurationSchema: ObjectSchema<{
  durationValue: number | null | undefined;
}> = object({
  durationValue: number()
    .nullable()
    .min(1, 'Enter between 1 to 30')
    .max(31, 'Enter between 1 to 30'),
});

export const allergyNameSchema: ObjectSchema<{ name: string }> = object({
  name: string()
    .trim()
    .max(100, 'Allergy Name must not exceed 100 characters')
    .required('Allergy Name Required'),
});

export function allergySchema(key: string): object {
  switch (key) {
    case 'name':
      return allergyNameSchema;
    case 'severity':
      return allergySeveritySchema;
    case 'duration':
      return allergyDurationSchema;
    default:
      return object({});
  }
}
